import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LeadsProvider } from './context/LeadsContext';
import Sidebar, { ALTURA_TOPO } from './components/Sidebar';
import Protegido from './components/Protegido';
import AvisoConvite from './components/AvisoConvite';
import Home from './pages/Home';
import ExtractorMaps from './pages/ExtractorMaps';
import ExtractorInstagram from './pages/ExtractorInstagram';
import MeusLeads from './pages/MeusLeads';
import Disparo from './pages/Disparo';
import Agendamentos from './pages/Agendamentos';
import Clientes from './pages/Clientes';
import Kanban from './pages/Kanban';
import Migrador from './pages/Migrador';
import Calculadora from './pages/Calculadora';
import Configuracoes from './pages/Configuracoes';
import Relatorios from './pages/Relatorios';
import Carteira from './pages/Carteira';
import Equipe from './pages/Equipe';
import WhatsApp from './pages/WhatsApp';

// Cada rota declara a área a que pertence (a matriz está em permissoes.js).
// Sem isso, esconder o item do menu seria só decoração: bastava digitar a
// URL para cair na tela.
const P = ({ area, children }) => <Protegido area={area}>{children}</Protegido>;

// A tela do WhatsApp usa a largura inteira: o menu sai da lateral e vira
// uma barra em cima. As outras telas continuam como sempre foram.
const TELAS_LARGAS = ['/whatsapp'];

function Moldura() {
  const { pathname } = useLocation();
  const larga = TELAS_LARGAS.includes(pathname);
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar topo={larga} />
      <main style={larga ? {
        marginTop: ALTURA_TOPO + 'px', flex: 1, minWidth: 0,
        minHeight: `calc(100vh - ${ALTURA_TOPO}px)`, background: '#f4f4f9', padding: '12px'
      } : {
        // minWidth 0: a página nunca passa da largura da tela. Sem isso, um
        // Kanban com muitas colunas alargava a página inteira e empurrava os
        // botões do topo (+ Lead) para fora da tela; agora só o quadro rola.
        marginLeft: '220px', flex: 1, minWidth: 0,
        minHeight: '100vh', background: '#f4f4f9', padding: '32px'
      }}>
        <AvisoConvite />
        <Routes>
          <Route path="/"             element={<P area="home"><Home /></P>} />
          <Route path="/maps"         element={<P area="leads"><ExtractorMaps /></P>} />
          <Route path="/instagram"    element={<P area="leads"><ExtractorInstagram /></P>} />
          <Route path="/meus-leads"   element={<P area="leads"><MeusLeads /></P>} />
          <Route path="/disparo"      element={<P area="disparo"><Disparo /></P>} />
          <Route path="/agendamentos" element={<P area="disparo"><Agendamentos /></P>} />
          <Route path="/whatsapp"     element={<P area="whatsapp"><WhatsApp /></P>} />
          <Route path="/clientes"     element={<P area="clientes"><Clientes /></P>} />
          <Route path="/carteira"     element={<P area="carteira"><Carteira /></P>} />
          <Route path="/kanban"       element={<P area="kanban"><Kanban /></P>} />
          <Route path="/migrador"     element={<P area="migrador"><Migrador /></P>} />
          <Route path="/calculadora"  element={<P area="calculadora"><Calculadora /></P>} />
          <Route path="/config"       element={<P area="config"><Configuracoes /></P>} />
          <Route path="/relatorios"   element={<P area="relatorios"><Relatorios /></P>} />
          <Route path="/equipe"       element={<P area="equipe"><Equipe /></P>} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LeadsProvider>
          <Moldura />
        </LeadsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
